import React from "react";
import classNames from "classnames";
import { UseCases } from "@planzone/core";
import { useMilestoneEdition } from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectList } from "@common/selectList";

import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";
import { CompletionIcon } from "./completionIcon";
import { ToggleArrow } from "./toggleArrow";

function MilestoneCompletion({ milestone, isEditable = true }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const { editMilestone } = useMilestoneEdition(milestone);
  const isCompleted = milestone.state === "DONE";

  return isEditable ? (
    <SelectList
      listClassName={styles.listRoot}
      rootClassName={classNames({ [styles.done]: isCompleted })}
    >
      {({ isOpen, select }) => ({
        input: (
          <div className={classNames(styles.input, { [styles.open]: isOpen })}>
            <p className={styles.name}>
              {isCompleted
                ? t("milestoneStatuses.DONE")
                : t("milestoneStatuses.TODO")}
            </p>
            <div className={styles.iconBox}>
              <ToggleArrow className={styles.icon} style={{}} />
            </div>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {isCompleted ? (
              <div
                className={styles.item}
                onClick={() =>
                  editMilestone({
                    milestone,
                    nextMilestone: { ...milestone, state: "TODO" },
                  })
                }
              >
                <p className={styles.name}>{t("milestoneStatuses.TODO")}</p>
              </div>
            ) : (
              <div
                className={styles.item}
                onClick={() =>
                  pushView({
                    key: UseCases.markMilestoneAsCompleted,
                    data: milestone,
                  })
                }
              >
                <p className={classNames(styles.name, styles.doneName)}>
                  {t("milestoneStatuses.DONE")}
                </p>
              </div>
            )}
          </div>
        ),
      })}
    </SelectList>
  ) : (
    <div className={classNames(styles.input, styles.readOnly)}>
      <p className={styles.name}>
        {isCompleted
          ? t("milestoneStatuses.DONE")
          : t("milestoneStatuses.TODO")}
      </p>
    </div>
  );
}

export { MilestoneCompletion };
